var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section section--text-align-center only-mobile section--FaqMobileLink"},[_c('a',{staticClass:"FaqMobileLink",attrs:{"href":"https://coronacheck.nl/nl/faq"}},[_vm._v(" "+_vm._s(_vm.$t('components.faq.viewFaq'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }